var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
      ]),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-primary",
            attrs: { type: "button" },
            on: { click: _vm.download },
          },
          [_vm._v("フォーマットを出力する")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-11" }, [
        _c(
          "form",
          {
            attrs: { enctype: "multipart/form-data" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.upload.apply(null, arguments)
              },
            },
          },
          [
            _c("input", {
              ref: "file",
              attrs: { type: "file", name: "csvfile" },
              on: { change: _vm.selectedFile },
            }),
            _c("button", { staticClass: "btn btn-info" }, [_vm._v("Upload")]),
          ]
        ),
      ]),
    ]),
    _c("p", [_vm._v(_vm._s(_vm.message))]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("import CSV")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }